"use client";

import { basketCounter, counterContainer } from "../BasketCount/style.css";
import React, { useEffect } from "react";
import { useRouter } from "../../../lib/router";
import { useUser } from "../../../lib/user";

export function BurgerNotification() {
  const [notificationClicked, setNotificationClicked] =
    React.useState<boolean>(true);
  const { isMember } = useUser();

  const router = useRouter();

  const isOrderItAgainPage = router.pathname.includes(
    "/account/favourites/order-it-again"
  );

  useEffect(() => {
    setNotificationClicked(!!localStorage.getItem("HIGHLIGHTED_NAV_ITEM"));
  }, []);
  if (notificationClicked || isOrderItAgainPage || !isMember) {
    return <></>;
  }
  return (
    <div className={counterContainer}>
      <span
        className={basketCounter}
        style={{
          color: "white",
          fontSize: "0.5rem"
        }}
        data-testid="basket-count"
        aria-label="Basket Count"
      >
        1
      </span>
    </div>
  );
}
